const recommendationKPICache = new Map();

export function getRecommendationKPIFromCache(pickupId) {
  return recommendationKPICache.get(pickupId);
}

export function setRecommendationKPIInCache(pickupId, data) {
  recommendationKPICache.set(pickupId, data);
}

export function clearRecommendationKPICache() {
  recommendationKPICache.clear();
}
